const revenueBySublet = (revenues: any) => {
  let data: any = [];
  const result = revenues.filter(
    (revenue: any) => revenue._id === "PNT SUB"
  )[0];
  const sublet = result === undefined ? [] : result;

  sublet?.list?.forEach((subl: any) => {
    subl?.list?.forEach((item: any) => {
      data.push(item);
    });
  });

  return { sublet, data };
};

export default revenueBySublet;
